export function handlingErrorMessage(errorCode: string) {
  let errorMessage = "";

  switch (errorCode) {
    case "auth/invalid-email":
      errorMessage = "Invalid username or password.";
      break;
    case "auth/wrong-password":
      errorMessage = "Invalid username or password.";
      break;
    case "auth/user-not-found":
      errorMessage = "User not found.";
      break;
    case "auth/email-already-in-use":
      errorMessage = "Email already in use.";
      break;
    case "auth/weak-password":
      errorMessage = "Weak password. Please choose a stronger password.";
      break;
    case "auth/user-disabled":
      errorMessage = "User disabled";
      break;
    case "auth/code-expired":
      errorMessage = "Code expired";
      break;
    case "auth/expired-action-code":
      errorMessage = "Action code is expired";
      break;
    case "auth/invalid-verification-code":
      errorMessage = "Verification code is invalid";
      break;
    case "auth/timeout":
      errorMessage = "Please try again.";
      break;
    case "auth/account-exists-with-different-credential":
      errorMessage = "Email already in use";
      break;

    default:
      errorMessage =
        "Oops something went wrong. Please try again later or contact support";
  }

  return errorMessage;
}
